import Card from '@/components/Card';

const StepsList = ({ steps }) => (
  <div className="flex flex-col space-y-6 py-5">
    {steps.map((step, index) => (
      <div className="flex space-x-4 items-start" key={index}>
        <div className="rounded-full h-10 w-10 bg-mmj-blue flex items-center justify-center text-lg font-bold text-white flex-shrink-0">
          {index + 1}
        </div>
        <div className="flex-1 pt-1">
          <h4 className="text-lg font-bold">{step.title}</h4>
          <p className="text-sm text-gray-600 mt-1">{step.description}</p>
          {step.link && (
            <a
              href={step.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-sm font-medium text-mmj-blue hover:underline"
            >
              {step.linkText || step.link}
            </a>
          )}
        </div>
      </div>
    ))}
  </div>
);

const StateOnboardingSteps = ({
  stateName,
  newSteps,
  renewalSteps,
  fee,
  cardDuration,
}) => {
  if (
    (!newSteps || newSteps.length === 0) &&
    (!renewalSteps || renewalSteps.length === 0)
  ) {
    return (
      <Card>
        <div className="py-4 text-center text-gray-600">
          <p className="font-bold text-lg mb-2">
            Need help with your state registration?
          </p>
          <p>
            Contact{' '}
            <a
              href="mailto:support@MMJ.com"
              className="text-mmj-blue underline"
            >
              support@MMJ.com
            </a>{' '}
            for help with your state&#39;s registration process.
          </p>
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {newSteps && newSteps.length > 0 && (
        <Card>
          <div className="space-y-2">
            <h2 className="font-bold text-xl text-mmj-header">
              Getting Your {stateName} Medical Marijuana Card
            </h2>
            {(fee || cardDuration) && (
              <div className="flex flex-wrap gap-x-4 text-sm text-gray-500">
                {fee && <span>Fee: {fee}</span>}
                {cardDuration && <span>Card Duration: {cardDuration}</span>}
              </div>
            )}
          </div>
          <StepsList steps={newSteps} />
        </Card>
      )}
      {renewalSteps && renewalSteps.length > 0 && (
        <Card>
          <div className="space-y-2">
            <h2 className="font-bold text-xl text-mmj-header">
              Renewing Your {stateName} Medical Marijuana Card
            </h2>
          </div>
          <StepsList steps={renewalSteps} />
        </Card>
      )}
    </div>
  );
};

export default StateOnboardingSteps;
